import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
@Component({
  selector: 'app-checkbox-property',
  templateUrl: './checkbox-property.component.html',
  styleUrls: ['./checkbox-property.component.scss']
})
export class CheckboxPropertyComponent implements OnInit {
  private _attributes: any;
  public booleanAttributes: Array<any> = [];

  @Input() component: any;
  @Input() set attributes(value: any) {
    this._attributes = value;

    if (this._attributes) {
      this.booleanAttributes = _.sortBy(
        this._attributes.filter((att: any) => {
          return att.type === 'boolean';
        }),
        ['name']
      );
    }
  }

  get attributes(): any {
    return this._attributes;
  }

  @Output() onBindVariableChange: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  handleOnBindVariableChange($event: any) {
    this.onBindVariableChange.emit({
      value: $event,
      id: this.component.id
    });
  }

  onLabelChange(label: string) {
    // Update field name: convert to lowercase, replace spaces/special chars with underscores
    this.component.element.field_name = label
      ? label.toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')  // Replace non-alphanumeric chars with underscore
          .replace(/^_+|_+$/g, '')       // Remove leading/trailing underscores
          .replace(/_+/g, '_')           // Replace multiple underscores with single
          .substring(0, 100)             // Limit to 100 characters
      : '';
  }
}
